<template>
  <div class="d-flex" :class="useColumn ? 'flex-column' : 'flex-row ml-6'">
    <!-- <a
      class="pr-2"
      target="_blank"
      :href="contact.startsWith('/') ? undefined : contact"
       @click="setType('Contact', contact)"
      :class="
        this.$parent.light || $vuetify.theme.dark === true
          ? 'txt-light'
          : 'txt-dark'
      "
    >
      {{ $t("footer.contact") }}
    </a> -->

    <a
      class="pr-2"
      target="_blank"
      :href="dataprivacy.startsWith('/') ? undefined : dataprivacy"
      :class="
        this.$parent.light || $vuetify.theme.dark === true
          ? 'txt-light'
          : 'txt-dark'
      "
      @click="setType('Dataprivacy', dataprivacy)"
    >
      {{ $t("footer.dataprivacy") }}
    </a>
    <a
      class="pr-2"
      target="_blank"
      :href="imprint.startsWith('/') ? undefined : imprint"
      :class="
        this.$parent.light || $vuetify.theme.dark === true
          ? 'txt-light'
          : 'txt-dark'
      "
      @click="setType('Imprint', imprint)"
    >
      {{ $t("footer.imprint") }}
    </a>

    <v-dialog v-model="dialog" scrollable min-width="50vw" max-width="768">
      <component v-bind:is="this.type" />
    </v-dialog>
  </div>
</template>

<script>
import EventBus from "_shared/EventBus";
import Imprint from "../policy/Imprint";
import Dataprivacy from "../policy/Dataprivacy";
// import Contact from "../policy/Contact";

export default {
  components: {
    Imprint,
    Dataprivacy,
    // Contact
  },
  props: {
    useColumn: Boolean,
  },

  data: () => ({
    dataprivacy: "",
    imprint: "",
    // contact: "",
    dialog: false,
    type: "",
  }),
  async created() {
    this.dataprivacy = (
      await window.axios.get("api/webapp/config?key=config.dataprivacy")
    ).data.value;
    this.imprint = (
      await window.axios.get("api/webapp/config?key=config.imprint")
    ).data.value;
    // this.contact = (
    //   await window.axios.get("api/webapp/config?key=config.contact")
    // ).data.value;

    EventBus.$on("showDialog", (payload) => {
      console.log("ev")
      this.dialog = payload.show;
      this.type = payload.type;
    });
  },
  onBeforeDestroy() {
    EventBus.$off("showDialog");
  },
  methods: {
    setType(type, link) {
      if (link.startsWith("/")) {
        this.dialog = !this.dialog;
        this.type = type;
      }
    },
  },
};
</script>

<style>
</style>